import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const LoginForm = ({ onSubmit, isLoading, error }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear validation error when user starts typing
    if (validationErrors?.[name]) {
      setValidationErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData?.email?.trim()) {
      errors.email = 'البريد الإلكتروني مطلوب';
    } else if (!/\S+@\S+\.\S+/?.test(formData?.email)) {
      errors.email = 'يرجى إدخال بريد إلكتروني صحيح';
    }
    
    if (!formData?.password?.trim()) {
      errors.password = 'كلمة المرور مطلوبة';
    } else if (formData?.password?.length < 6) {
      errors.password = 'كلمة المرور يجب أن تكون 6 أحرف على الأقل';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Email Input */}
      <div>
        <Input
          label="البريد الإلكتروني"
          type="email"
          name="email"
          value={formData?.email}
          onChange={handleInputChange}
          placeholder="admin@ssu.org"
          error={validationErrors?.email}
          required
          disabled={isLoading}
          className="text-right"
          dir="rtl"
        />
      </div>
      {/* Password Input */}
      <div className="relative">
        <Input
          label="كلمة المرور"
          type={showPassword ? 'text' : 'password'}
          name="password"
          value={formData?.password}
          onChange={handleInputChange}
          placeholder="••••••••"
          error={validationErrors?.password}
          required
          disabled={isLoading}
          className="text-right pr-12"
          dir="rtl"
        />
        
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute left-3 top-9 text-muted-foreground hover:text-foreground transition-colors"
          disabled={isLoading}
        >
          <Icon 
            name={showPassword ? 'EyeOff' : 'Eye'} 
            size={18}
          />
        </button>
      </div>
      {/* Global Error Message */}
      {error && (
        <div className="bg-error/10 border border-error/20 rounded-lg p-3 text-right" dir="rtl">
          <div className="flex items-center space-x-2 space-x-reverse">
            <Icon name="AlertCircle" size={16} className="text-error flex-shrink-0" />
            <p className="text-sm text-error">{error}</p>
          </div>
        </div>
      )}
      {/* Submit Button */}
      <Button
        type="submit"
        variant="default"
        size="lg"
        fullWidth
        loading={isLoading}
        disabled={isLoading}
        className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
      >
        {isLoading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
      </Button>
      {/* Forgot Password Link */}
      {/* <div className="text-center">
        <button
          type="button"
          className="text-sm text-accent hover:text-accent/80 transition-colors font-medium"
          onClick={() => {
            // Mock forgot password functionality
            alert('سيتم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني');
          }}
          disabled={isLoading}
        >
          نسيت كلمة المرور؟
        </button>
      </div> */}
    </form>
  );
};

export default LoginForm;